Vue.component('workflow-campaign-list', require('./WorkflowCampaignList').default);
Vue.component('workflow-campaign-list-item', require('./WorkflowCampaignListItem').default);
Vue.component('workflow-campaign-form', require('./WorkflowCampaignForm').default);
Vue.component('workflow-campaign-form-template', require('./WorkflowCampaignFormTemplate').default);

Vue.component('sequence-preview-sms', require('./WorkflowPreviewSms').default);
Vue.component('sequence-preview-email', require('./WorkflowPreviewEmail').default);